<template>
	<RouterView />
	<Notice />
	<Confirm />
</template>

<script>
import { useHead } from '@unhead/vue'

import '@/styles/partials.scss'

export default {
	name: 'App',
	setup() {
		useHead({
			titleTemplate: '%s | Sentencing Pro',
			title: `Federal Sentencing Guidelines Calculator`
		})
	},
	data: () => ({
		registration: null,
		needRefresh: false,
	}),
	mounted() {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('/sw.js')
				.then(reg => {
					this.registration = reg
console.log('[serviceWorker].waiting', reg)
					if (!reg.waiting) return
					if (reg.waiting) {
						this.needRefresh = true
					}

					reg.onupdatefound = () => {
						const installingWorker = reg.installing
						installingWorker.onstatechange = () => {
console.log('[serviceWorker].state', installingWorker.state)
							if (installingWorker.state === 'installed') {
								if (reg.waiting) {
									this.needRefresh = true
								}
							}
						}
					}

					reg.onupdated = () => {
console.log('[serviceWorker].onupdated')
						this.needRefresh = true
					}

					navigator.serviceWorker.addEventListener('controllerchange', () => {
						if (this.registration && this.registration.waiting) {
console.log('[serviceWorker].controllerchange')
							this.needRefresh = true;
						}
					})
				})
				.catch(error => console.error('Service Worker registration failed:', error))
		}

		window.addEventListener('focus', () => {
			try {
				this.registration?.update()
			} catch (e) {
				console.warn('sw.catch.update', e)
			}

			if (this.registration && this.registration.waiting) {
				this.needRefresh = true

			}
		})
	},
	methods: {
		showReload() {
			this.$notice.show(`A new VERSION is available!`, {
				actionLabel: `UPDATE NOW`,
				action: () => {
					if (this.registration && this.registration.waiting) {
						this.registration.waiting.postMessage({ type: 'SKIP_WAITING'})
					} else if (navigator.serviceWorker && navigator.serviceWorker.controller) {
						navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING'})
					}
					setTimeout(() => {
						window.location.reload()
					}, 1000)
				},
				timeout: -1,
				hideClose: true,
			})
		}
	},
	watch: {
		needRefresh: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == true && newVal != oldVal) {
					this.showReload()
				}
			},
		}
	}
}

</script>

<style lang="scss">
// @use 'styles/partials';

@include modules.media-query('phone') {
	.partial {
		padding: 0 !important;

		&__heading {
			align-items: flex-start;
			padding: 0 1rem;
		}
	}
}

</style>
